import React, { useEffect, useState } from "react";
import styled from "styled-components";
//date 
import moment from 'moment';
// styling
import { Colors, Spacing } from "_styles";
import * as TaskColors from "../utils/colors";
import "./job-card.css"
// icons
import { IoIosAirplane } from "react-icons/io";
import { MdFreeBreakfast } from "react-icons/md";
import { IoDuplicateOutline } from "react-icons/io5";

// redux
import { useSelector, useDispatch } from "react-redux";
import { selectUserDb } from "_redux/slices/main-screen/user";
import { setPoints, setClicked, setClickedJob } from "_redux/slices/utils/menu-context";
import {
    selectSelectedTask,
    setSelectedTask,
    setSelectedTaskList,
    selectSelectedTasksList,
} from "_redux/slices/timeline/selected-task";
import { selectOutboundFlights, selectInboundFlights, selectFlightListIndexed } from '_redux/slices/timeline/flight-information-list';

// utils
import { getTaskCardStatus, getJobStatusColor, capitalizeWords } from "_utils/functions";
import TaskAccept from "./task-accept";
import { useInterval } from "_utils/hooks";
import { EmployeeJobCardWidth, JobCardWidth, JobCard30MinLayoutWidth, SaudiDomesticAirports, minuteWidth, JobCardHeight, minute30MinLayoutWidth } from "_utils/timeline-constants";
import { mainContainer, flightNumberParagraph, assistanceParagraph, statusCircle, breakTaskCounter } from "./job-styles";
import { selectPreBoard } from "_redux/slices/timeline/timeline-control";

// icons
import { GoPerson } from "react-icons/go";

// components
import JobCardStatus from "./job-card-status";
import { selectBookingSearch } from "_redux/slices/timeline/timeline-data";
import { PRMCodes } from "_utils/constants";

const GreyText = styled.p`
  margin: 0;
  text-align: center;
  font-size: 8px;
`;


function capitalize(string) {
    if (string[0]) {
        return string[0].toUpperCase() + string.slice(1).toLowerCase();
    } else return string;
}

function processName(paxName) {
    if (paxName === "Pax 1" || paxName === "n/a") return paxName;
    let fullName = paxName.split(" ");

    const first = fullName[0], second = fullName.slice(1).join(" ")
    if (!first && !second) { return '' }
    // MR MISS MRS MS
    if (first.slice(first.length - 3) == 'MRS') {
        return ('Mrs ' + capitalize(first.substring(0, first.length - 3)) + ' ' + capitalize(second))
    }
    else if (first.slice(first.length - 2) == 'MS') {
        return ('Ms ' + capitalize(first.substring(0, first.length - 2)) + ' ' + capitalize(second))
    }
    else if (first.slice(first.length - 2) == 'MR') {
        return ('Mr ' + capitalize(first.substring(0, first.length - 2)) + ' ' + capitalize(second))
    }
    else if (first.slice(first.length - 4) == 'MISS') {
        return ('Miss ' + capitalize(first.substring(0, first.length - 4)) + ' ' + capitalize(second))
    }
    else {
        return (capitalize(first) + ' ' + capitalize(second))
    }
}


// component to preview combined passengers as icons
const GroupedPassengers = ({ groupedPassengers, flightType }) => {

    if (Array.isFullArray(groupedPassengers) && groupedPassengers?.length < 3) {

        return <div style={{ maxHeight: "15px", alignItems: "baseline", display: "flex" }}>
            {groupedPassengers.map((passenger, index) => <GoPerson size={15} key={index} color={flightType === "departure" ? TaskColors.internationalDepartures : TaskColors.domesticArrivals} />)}
        </div>
    } else if (Array.isFullArray(groupedPassengers) && groupedPassengers?.length >= 3) {

        return <div style={{ maxHeight: "15px", alignItems: "baseline", display: "flex" }}>
            <GoPerson size={15} color={flightType === "departure" ? TaskColors.internationalDepartures : TaskColors.domesticArrivals} /> {`...+${groupedPassengers?.length - 1}`}
        </div>
    } else {
        return <div style={{ maxHeight: "15px" }}>
            <GreyText style={{ textAlign: "left", fontSize: 8 }}>
                {capitalizeWords("No Name")}
            </GreyText>
        </div>
    }
}

const ThirtyMinLayoutJobCard = (props) => {

    //#region redux
    const dispatch = useDispatch();
    const userDb = useSelector(selectUserDb);

    // selected task redux
    const selectedTask = useSelector(selectSelectedTask);
    const selectedTasksList = useSelector(selectSelectedTasksList);
    const preBoard = useSelector(selectPreBoard);                                   // status of auto accept unplaned task switch
    const bookingSearch = useSelector(selectBookingSearch);

    // flight list
    //const flightsByHour = useSelector(selectFlightsByHour)                               // list of flights grouped by hour
    const inboundFlights = useSelector(selectInboundFlights);
    const outboundFlights = useSelector(selectOutboundFlights);
    const flightList = useSelector(selectFlightListIndexed)

    //#endregion

    //#region local states
    const [flightNumber, setFlightNumber] = useState("");                           // flight number of booking
    const [displayFlightNumber, setDisplayFlightNumber] = useState("");             // display flight number of booking
    const [departure, setDeparture] = useState("");                                 // departure airport of booking
    const [arrival, setArrival] = useState("");                                     // arrival airport of booking
    const [displayedAssistance, setDisplayedAssistance] = useState("WCHR");         // passenger assistance
    const [time, setTime] = useState("");                                           // time of flight departure / arrival
    const [flightType, setFlightType] = useState("");                               // type of flight (inbound or outbound)
    const [jobStatusLine, setJobStatusLine] = useState("Not Assigned");             // status of job
    const [borderColor, setBorderColor] = useState("lightgray");                    // border color of job card
    const [toggleAcceptModal, setToggleAcceptModal] = useState(false);
    const [downTimer, setDownTimer] = useState({
        taskId: props?.job?._id,
        timer: false,
        remainingTime: null,
    });
    const [breakTaskPeriod, setBreakTaskPeriod] = useState("")                      // holds value of the break task period
    const [boardingStarted, setBoardingStarted] = useState(false)                   // check if boarding has started

    const [jobCardWidth, setJobCardWidth] = useState(0)                  // default job card with to be 30 min default sizing

    // gate + terminal information
    const [gateInformation, setGateInformation] = useState("")
    const [standInformation, setStandInformation] = useState("")
    const [terminalInformation, setTerminalInformation] = useState("")

    const [isALTPickUp, setIsAltPickup] = useState(false);        // if alt pickup we need to change color and add pickup location to card
    const [pickupLocation, setPickupLocation] = useState("");    // pickup location of the alt pickup
    const [showStatus, setShowStatus] = useState(true);        // by default show current assignment status of the job (assigned, pending, complete etc.)
    const [name, setName] = useState('')                        // name of the passenger
    const [highlightedJob, setHighlightedJob] = useState(false);
    //#endregion

    //#region useEffect

    useEffect(() => {
        if (props.timelineJobs) {
            setShowStatus(false)
        }
    }, [props]);

    // take name if it is a departure
    useEffect(() => {
        if (props.job && !props?.job?.combinedBooking && !props?.job?.combinedRampBooking) {
            if (flightType == 'departure') {
                if (props.job.passengerInformation) {
                    if (props.job.passengerInformation.name) {
                        setName(processName(props.job.passengerInformation.name))
                    }
                    else if (props.job.passengerInformation.title) {
                        setName(processName(props.job.passengerInformation.title))
                    }
                }
                else if (props.job.name) {
                    setName(processName(props.job.name))
                }

            }
        }
    }, [flightType, props.job]);

    useEffect(() => {
        if (props.job && !props?.job?.combinedBooking && !props?.job?.combinedRampBooking && bookingSearch) {
            if (flightType == 'departure') {
                if (props.job.passengerInformation) {
                    if (props.job.passengerInformation.name && props.job.passengerInformation.name.includes(bookingSearch.toUpperCase())) {
                        setHighlightedJob(true)
                    }
                    else if (props.job.passengerInformation.title && props.job.passengerInformation.title.includes(bookingSearch.toUpperCase())) {
                        setHighlightedJob(true)
                    } else setHighlightedJob(false)
                }
                else if (props.job.name && props.job.name.includes(bookingSearch.toUpperCase())) {
                    setHighlightedJob(true)
                } else setHighlightedJob(false)

            }
        }
        if (!bookingSearch) setHighlightedJob(false)
    }, [flightType, props.job, bookingSearch]);

    useEffect(() => {
        if (props.job) {
            if (props.job.isALTPickUp) {
                setIsAltPickup(true)
                if (props.job.pickUpLocation) {
                    if (props.job.pickUpLocation.name) {
                        setPickupLocation(props.job.pickUpLocation.name)
                    }
                }
            }
        }
    }, [props.job]);

    // check if the task is a combined booking or combined ramp booking and if boarding has started
    useEffect(() => {
        if (props?.job?.combinedBooking || props?.job?.combinedRampBooking) {
            // check if boarding has started
            if (props?.job?.boardingStarted && !props?.job?.completed) {
                // need to show icon etc.
                setBoardingStarted(true)
            } else {
                setBoardingStarted(false)

            }
        }
    }, [props.job]);

    // extract gate info

    // extract gate info
    useEffect(() => {
        // check flight number
        if (flightNumber != "") {

            // check flight list is valid
            if (flightList && Object.keys(flightList) && Object.keys(flightList).length > 0) {

                // code switch if required
                let tempNumber = flightNumber;

                if (tempNumber.includes('EZY')) {
                    // need to replace 'EZY' with 'U2'
                    tempNumber = tempNumber.replace('EZY', 'U2');
                }

                // try find our flight
                let flightDocument = flightList[tempNumber];

                if (flightDocument != undefined) {
                    // check for gate / stand info
                    if (flightDocument.stand) {
                        setStandInformation(flightDocument.stand)
                    }
                    if (flightDocument.gate) {
                        setGateInformation(flightDocument.gate)
                    }
                }
                else {
                }

            }

        }
    }, [flightNumber, flightList]);

    /// set job states if there is no assignedTime ( means it is in task list)
    useEffect(() => {
        if (props.job.assignedTime == undefined || (props.job.flightConfirmationDetails != undefined && props.job.flightConfirmationDetails.departureTime != undefined)) {
            // listed booking, not assigned yet
            let carrierCode = props.job.flightConfirmationDetails.carrierCode;
            if (carrierCode == 'U2') { carrierCode = 'EZY' }
            setDisplayFlightNumber(carrierCode + props.job.flightConfirmationDetails.flightNumber);
            setFlightNumber(
                props.job.flightConfirmationDetails.carrierCode +
                props.job.flightConfirmationDetails.flightNumber
            );
            setDeparture(props.job.flightConfirmationDetails.origin);
            setArrival(props.job.flightConfirmationDetails.destination);

            if (userDb.details.authority === props?.job?.flightConfirmationDetails?.origin && props?.job?.flightConfirmationDetails?.departureTime) {
                setTime(getTimeString(props?.job?.passengerDutTime ? props?.job?.passengerDutTime : props?.job?.flightConfirmationDetails?.departureTime));
            } else if (
                userDb.details.authority ===
                props?.job?.flightConfirmationDetails?.destination &&
                props?.job?.flightConfirmationDetails?.arrivalTime
            ) {
                setTime(
                    getTimeString(props?.job?.flightConfirmationDetails?.arrivalTime)
                );
            }
            // check if the job has an rejectedPax change it's status to Rejected
            if (props?.job?.rejectedPax == true || props?.job?.originalBookingDoc?.rejectedPax == true) setJobStatusLine("Rejected");
            else setJobStatusLine("Not Assigned")
            if (Array.isFullArray(props?.job?.assistance)) {
                let tempAssistance = [...new Set(props?.job?.assistance.map(item => item?.match(/\b[A-Z]{4}\b/g)).flat().filter(Boolean))]
                tempAssistance = tempAssistance?.filter((row) => PRMCodes?.includes(row.trim()))


                // check if tempAssistance is an array and the length > 0
                if (Array.isFullArray(tempAssistance)) {
                    //check if the there is more than one assistance display only one with ...
                    if (tempAssistance?.length > 1) {
                        setDisplayedAssistance(tempAssistance.slice(0, 1)?.filter((row) => PRMCodes?.includes(row.trim())).join(", ") + `...+${tempAssistance?.length - 1}`);
                    } else {
                        setDisplayedAssistance(tempAssistance?.filter((row) => PRMCodes?.includes(row.trim())).join(", "));
                    }
                } else {
                    setDisplayedAssistance("WCHR");
                }
            }
        }
    }, [props.job]);

    // set job states if there is  assignedTime ( means it is in employee list)
    useEffect(() => {
        if (props.job && props.job.assignedTime != undefined && props?.job?.isBreakTask !== true) {
            // assigned booking
            if (props.job.flightInformation != undefined && props.job.flightInformation.flightNumber != undefined) {
                ;
                let number = props?.job?.flightInformation?.flightNumber;
                if (number.includes('U2')) { number = number.replace('U2', 'EZY') }
                setDisplayFlightNumber(number);
                setFlightNumber(props?.job?.flightInformation?.flightNumber);
            }

            setDeparture(props?.job?.flightInformation?.departureAirport);
            setArrival(props.job?.flightInformation?.arrivalAirport);
            if (props.job.flightInformation?.flightTime != undefined) {
                // setTime(getTimeString(props.job.flightInformation.flightTime));
                setTime(getTimeString(props?.job?.passengerDutTime ? props?.job?.passengerDutTime : props.job.flightInformation.flightTime));
            }
            if (Array.isFullArray(props?.job?.passengerInformation?.assistance)) {

                let tempAssistance = [...new Set(props?.job?.passengerInformation?.assistance.map(item => item.match(/\b[A-Z]{4}\b/g)).flat().filter(Boolean))]
                tempAssistance = tempAssistance?.filter((row) => PRMCodes?.includes(row.trim()))
                // let tempAssistance = props?.job?.passengerInformation?.assistance?.filter((row) => PRMCodes?.includes(row.trim()))
                // check if tempAssistance is an array and the length > 0
                if (Array.isFullArray(tempAssistance)) {
                    //check if the there is more than one assistance display only one with ...
                    if (tempAssistance?.length > 1) {
                        setDisplayedAssistance(tempAssistance.slice(0, 1)?.filter((row) => PRMCodes?.includes(row.trim())).join(", ") + `...+${tempAssistance?.length - 1}`);
                    } else {
                        setDisplayedAssistance(tempAssistance?.filter((row) => PRMCodes?.includes(row.trim())).join(", "));
                    }
                } else {
                    setDisplayedAssistance("WCHR");
                }
            }
            const cardStatus = getTaskCardStatus(props?.job)
            setJobStatusLine(cardStatus?.status)
            setBorderColor(cardStatus?.borderColor)
        }
    }, [props.job]);

    // set job states if it is a isBreakTask 
    useEffect(() => {
        if (props?.job?.isBreakTask) {
            const cardStatus = getTaskCardStatus(props?.job)
            setJobStatusLine(cardStatus?.status)
            setBorderColor(TaskColors.breakTasks)
            setTime(getTimeString(`${props.job?.breakTaskInformation?.breakTaskDate}T${props.job?.assignedTime}:00`));
            setDisplayedAssistance("");
            setBreakTaskPeriod(props.job?.breakTaskInformation?.breakTaskPeriod)
        }
    }, [props.job]);

    useEffect(() => {
        // check if it is an alternative pickup task set the gate and stand from the passed outboundFlights if there is outboundFlights
        if (props?.job?.isALTPickUp) {
            if (Array.isFullArray(props?.outboundFlights)) {
                let tempFlightInfo = props?.outboundFlights?.find((flight) => flight?.flightNumber === displayFlightNumber);
                if (tempFlightInfo?.gate) setGateInformation(tempFlightInfo?.gate ?? "N/A");
                if (tempFlightInfo?.stand) setStandInformation(tempFlightInfo?.stand ?? "N/A");
            }
        }

    }, [props.job, displayFlightNumber])

    // check if arrival or departure for logged in user
    useEffect(() => {
        if (arrival == userDb.details.authority) {
            setFlightType("arrival");
        } else {
            setFlightType("departure");
        }
    }, [arrival, departure]);

    function minutesSince(timeString) {
        const [hours, minutes] = timeString.split(':').map(Number); // Parse the input time
        const inputMinutes = hours * 60 + minutes; // Convert input time to total minutes since midnight

        const now = new Date();
        const currentMinutes = now.getHours() * 60 + now.getMinutes(); // Convert current time to total minutes since midnight

        return currentMinutes - inputMinutes; // Calculate the difference in minutes
    }

    function calculateMinuteDifference(time1, time2) {
        // Helper function to convert hh:mm to total minutes
        const timeToMinutes = (time) => {
            const [hours, minutes] = time.split(":").map(Number);
            return hours * 60 + minutes;
        };

        // Convert both times to total minutes
        const minutes1 = timeToMinutes(time1);
        const minutes2 = timeToMinutes(time2);

        // Calculate the absolute difference
        const difference = Math.abs(minutes2 - minutes1);

        return difference;
    }

    // check job card with is correct
    useEffect(() => {
        if (props.job) {
            // check if job is started
            if (!props.job.active && !props.job.completed) {


                // default sizing to 30 minutes
                setJobCardWidth(JobCard30MinLayoutWidth)
            }
            // check if job is started
            if (props.job.active && !props.job.completed) {

                // create width by calculating difference in minutes between assigned time and current time
                const assignedTime = props.job.assignedTime;

                let timeDifference = minutesSince(assignedTime);

                // set the job card width to be the time difference in minutes * 30
                let newJobWidth = timeDifference * minute30MinLayoutWidth;

                setJobCardWidth(newJobWidth);

            }
            // check if job completed
            if (props.job.completed) {

                let completeTime = props.job.completeTime

                let completeDate = new Date(completeTime.seconds * 1000 + Math.floor(completeTime.nanoseconds / 1e6));

                // format complete time properly
                const formattedTime = completeDate.toLocaleTimeString('en-US', {
                    hour: '2-digit',
                    minute: '2-digit',
                    hour12: false, // Use 24-hour format; change to true for 12-hour format
                });

                let assignedTime = props.job.assignedTime;

                // find time taken to complete job
                let timeDifference = calculateMinuteDifference(assignedTime, formattedTime);

                let newJobWidth = timeDifference * minute30MinLayoutWidth;

                setJobCardWidth(newJobWidth);


            }
        }
    }, [props.job]);

    //#endregion

    //#region functions

    // convert time string into hour + minutes string
    const getTimeString = (dateString) => {

        const dateObj = new Date(dateString);

        const options = { hour: "2-digit", minute: "2-digit", hour12: false };
        // convert dateString to the user current timeZone and take the time of it
        const formattedTime = dateObj.toLocaleString("en-US", options);
        return formattedTime;
    };
    function convertTimeStampToTime(timestamp) {
        if (timestamp == undefined || timestamp == null) {
            return;
        }
        // Convert seconds to milliseconds, 1e6 (1,000,000)
        const milliseconds = timestamp.seconds * 1000 + timestamp.nanoseconds / 1e6;

        // Format using Moment.js
        const formattedTime = moment(milliseconds).format("HH:MM");
        return formattedTime
    }

    const handleLeftClick = (e) => {
        // check if the job is break task and completed don't open context menu
        if (props?.job?.completed && props?.job?.isBreakTask) return;
        e.preventDefault();
        dispatch(setClicked(true));
        dispatch(setPoints({ x: e.pageX, y: e.pageY }));
        dispatch(setClickedJob(props.job));
    };

    const handleJobClick = (e) => {

        // check if click was double click
        if (e.detail === 2) { return; /* do not do anything if double click */ }

        // check if the pax is rejected 
        if (props?.job?.rejectedPax == true || props?.job?.originalBookingDoc?.rejectedPax == true) return;

        // props?.disabled == true refers that the job is assigned to an employee
        if (props?.disabled) {
            // props.job?.pending == true refers that the job is in pending status and waits for approve
            if (props.job?.pending) setToggleAcceptModal(true);
            return;
        }
        // check if there is a list of job selected and viewed to be assigned
        if (props?.toConfirm == true) {
            // check if selected task is null and if its the same task
            if (selectedTask != null && selectedTask?._id == props?.job?._id) {
                // selected task is current job, unselect it
                if (props?.clicked?.includes(props?.job["_id"])) {
                    props?.setClicked(null);
                    dispatch(setSelectedTask(null));
                }
            } else {
                props?.setClicked(props?.job["_id"]);
                dispatch(setSelectedTask(props.job));
            }
        } else {
            // set selected job lists by click on job cards
            // selected taks id
            let selectedTasksIds = Array.isFullArray(selectedTasksList)
                ? selectedTasksList?.map((element) => element?._id)
                : [];
            // check if the selected tasks list include the selected task or not
            if (selectedTasksIds?.includes(props?.job["_id"])) {
                // remove the clicked task from selected tasks list
                dispatch(
                    setSelectedTaskList(
                        selectedTasksList?.filter((item) => item?._id != props?.job["_id"])
                    )
                );
                props?.setClicked(
                    selectedTasksIds?.filter((item) => item != props?.job["_id"])
                );
            } else {
                dispatch(setSelectedTaskList([...selectedTasksList, props.job]));
                props?.setClicked([...selectedTasksIds, props?.job["_id"]]);
            }
        }
    };

    // set the card top border color by the task status
    const handleCardTopColor = () => {
        if (props?.job?.isALTPickUp) { return TaskColors.ALTPickUps }
        if (props?.job?.isBreakTask) return TaskColors.breakTasks
        if (props?.job?.isTransitBooking == true
            && props?.job?.pending !== true
            && props?.job?.active !== true
            && props?.job?.cancelled !== true
            && props?.job?.completed !== true) {
            return TaskColors.transitBookings
        }
        if (props?.job?.pending == true) {
            return TaskColors.pendingTasks

        };
        if (props?.job?.active == true) return TaskColors.activeTasks;
        if (props.job.cancelled == true) return TaskColors.rejectedTasks;
        if (props?.job?.completed == true) return TaskColors.completedTasks;
        if (props?.job?.stopped == true) return TaskColors.rejectedTasks;

        if (flightType == "arrival") {
            if (SaudiDomesticAirports?.includes(userDb.details.authority) && SaudiDomesticAirports?.includes(departure)) {
                return TaskColors.domesticArrivals
            } else {
                return TaskColors.internationalArrivals
            }
        }
        if (flightType == "departure") {
            if (props?.job?.isALTPickUp) return TaskColors.internationalDepartures
            if (SaudiDomesticAirports?.includes(userDb.details.authority) && SaudiDomesticAirports?.includes(arrival)) {
                return TaskColors.domesticDepartures
            } else if (preBoard && props?.disabled && props?.job?.combinedBooking == true) {
                return TaskColors.departures
            } else if (preBoard && props?.job?.isEstimatedBooking !== true && !props?.job?.assignedTime) {
                return TaskColors.departures
            } else return TaskColors.internationalDepartures
        }
        return "lightgrey";
    };

    const closeModal = () => {
        setToggleAcceptModal(false);
    };

    //#endregion

    //#region custom Hooks
    useInterval(async () => {
        const job = props.job
        if (
            !job ||
            job?.completed == true ||
            job?.cancelled == true ||
            job?.notPlanned == true ||
            job?.isBreakTask !== true ||
            job?.active !== true
        )
            return;

        const startTime = job.startTime;
        //get the task period, breakTaskPeriod will be like 15 Minutes or 1 hour
        const breakTaskPeriod = job.breakTaskInformation.breakTaskPeriod.includes("Minutes") ? job.breakTaskInformation.breakTaskPeriod.split(" ")[0] : 60;

        const startTimeInMillis = (startTime.seconds * 1000) + (startTime.nanoseconds / 1e6);
        // Create a Date object for the start time
        const startDate = new Date(startTimeInMillis);

        const endDate = new Date(startDate.getTime() + Number(breakTaskPeriod) * 60000); // 60000 ms = 1 minute
        const currentTime = new Date(); // Current time

        //Calculate the difference in milliseconds
        const timeRemaining = endDate.getTime() - currentTime.getTime();
        if (timeRemaining > 0) {
            const minutesRemaining = Math.floor(timeRemaining / 60000);

            setDownTimer((prev) => ({
                ...prev,
                taskId: job?._id,
                timer: true,
                remainingTime: minutesRemaining,
            }));
        } else {
            setDownTimer((prev) => ({
                ...prev,
                taskId: job?._id,
                timer: false,
                remainingTime: 0,
            }));
        }
    }, 60000);
    //#endregion

    // error checking
    if (props.job == undefined || props.job["_id"] == undefined) {
        return <p>error</p>;
    }

    const ResizableCard = (innerProps) => {
        return (
            <div style={{ width: props?.disabled ? jobCardWidth : EmployeeJobCardWidth }}>

                {innerProps.children}
            </div>
        )
    }

    return (
        <>

            <div onClick={handleJobClick} style={{
                // height: JobCardHeight,
                width: props?.disabled ? jobCardWidth : EmployeeJobCardWidth,
                zIndex: 1,
                position: props.position ? props.position : 'relative',
                overflowX: 'hidden',
                top: 10
                //borderStyle:'solid', borderWidth:1,
            }}>
                <ResizableCard>
                    <div
                        onContextMenu={(e) => {
                            handleLeftClick(e);
                        }}
                        style={{
                            ...mainContainer,
                            borderLeftColor: props?.clicked?.includes(props?.job["_id"]) ? Colors.PRM_LIGHT_BLUE : borderColor,
                            borderRightColor: props?.clicked?.includes(props?.job["_id"]) ? Colors.PRM_LIGHT_BLUE : borderColor,
                            borderBottomColor: props?.clicked?.includes(props?.job["_id"]) ? Colors.PRM_LIGHT_BLUE : borderColor,
                            borderTopColor: handleCardTopColor(),
                            backgroundColor: props?.clicked?.includes(props?.job["_id"]) ? "#acbad5" : props?.job?.isBreakTask ? "#f7b9b9" : "white",
                            width: '100%',
                            // width: '100%', height: '100%'
                            // width: props?.disabled ? EmployeeJobCardWidth : JobCard30MinLayoutWidth,
                            boxShadow: highlightedJob && flightType === "departure"
                                ? `0 0 10px ${Colors.PRM_LIGHT_BLUE}, 0 0 20px ${Colors.PRM_LIGHT_BLUE}`
                                : highlightedJob && flightType === "arrival" ? `0 0 10px ${Colors.DARK_GREEN}, 0 0 20px ${Colors.DARK_GREEN}`
                                    : "none",
                            transition: highlightedJob ? "box-shadow 0.5s ease-in-out" : "none"
                        }}
                    >

                        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>

                            {/* break task symbol */}
                            {props?.job?.isBreakTask ?
                                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", gap: "10px" }}>
                                    <p style={flightNumberParagraph}>Break Task</p>
                                    <MdFreeBreakfast
                                        size={12}
                                        color={"black"}
                                        style={{ opacity: 0.6, marginLeft: Spacing.SCALE_4, marginRight: Spacing.SCALE_4 }}
                                    />
                                </div>
                                :

                                /* flight number + gate info */
                                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", gap: props?.disabled ? "4px" : "10px" }}>
                                    {/* flight number */}
                                    <p style={{ margin: "0px 0", textAlign: "center", fontSize: 11, fontWeight: '600' }}>{props?.job?.isBreakTask ? "Break Task" : displayFlightNumber}</p>

                                    <div style={{ display: 'flex' }}>
                                        {gateInformation != '' && gateInformation != 'N/A' && <p style={{ margin: "0px 0", textAlign: "center", fontSize: 11 }}>{'G' + gateInformation}</p>}
                                        <div style={{ width: 5, height: 5, borderRadius: 15, backgroundColor: borderColor, marginLeft: 2, marginRight: 2, marginTop: 4 }} />
                                        {standInformation != 'N/A' && <p style={{ margin: "0px 0", textAlign: "center", fontSize: 11 }}>{'S' + standInformation}</p>}
                                    </div>

                                </div>
                            }
                            <p style={{ margin: "0px 0", textAlign: "center", fontSize: 11 }}>
                                {time}
                            </p>

                        </div>

                        {/* horizontal line */}
                        <hr style={{ margin: "0px" }} />

                        {flightType == 'departure' && !props?.job?.combinedBooking && !props?.job?.combinedRampBooking &&
                            <div>
                                <p style={{ margin: "0px 0", fontSize: 8, fontWeight: "700", textWrapMode: "nowrap" }}>{name}</p>
                            </div>
                        }
                        {/* combinedBooking(departures combined booking),combinedRampBooking(arrivals combined ramp booking), selfAllocatedTask with passengers array, buggyTask(arrival task set with multiple passengers for buggy staff)  */}
                        {(props?.job?.combinedBooking || props?.job?.combinedRampBooking || (props?.job?._id?.includes("-selfAllocatedTask-") && props?.job?.passengers?.length > 1) || (props?.job?.buggyTask === true && props?.job?.flightBooking === true)) &&
                            <GroupedPassengers groupedPassengers={props?.job?.passengers} flightType={flightType} />
                        }

                        {/* alt pickup location */}
                        {isALTPickUp && jobStatusLine != 'Completed' &&
                            <div>
                                <p style={{ margin: "0px 0", fontSize: 8 }}>{pickupLocation}</p>
                            </div>
                        }

                        {/* boarding information */}
                        {boardingStarted &&
                            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                <div style={{ display: 'flex', justifyContent: "center", alignItems: "center" }}>
                                    <div className="glowing-circle"></div>
                                    <p style={{ margin: "0px 0", fontSize: 8 }}>Boarding Started</p>
                                </div>
                                <p style={{ margin: "0px 0", fontSize: 8 }}>{convertTimeStampToTime(props.job?.boardingStartTime)}</p>
                            </div>
                        }
                        {/* status information */}
                        <div style={{ display: "flex", justifyContent: "space-between", position: "relative", alignItems: "baseline" }}>
                            {downTimer?.taskId == props.job?._id &&
                                downTimer?.timer &&
                                props.job?.pending !== true &&
                                props.job?.isBreakTask &&
                                props.job?.cancelled != true &&
                                props.job?.notPlanned != true &&
                                props.job?.active === true && (

                                    <div style={breakTaskCounter}>
                                        <p style={{ color: "red", fontSize: 9, width: "100%", margin: 0 }}>{downTimer.remainingTime}M</p>
                                    </div>
                                )}
                            <p style={assistanceParagraph}>
                                {props?.job?.isBreakTask ? breakTaskPeriod : displayedAssistance}
                            </p>

                            {/* duplicate booking icon */}
                            {(!isNaN(props?.job?.duplicateVersion) || !isNaN(props?.job?.originalBookingDoc?.duplicateVersion)) && <div><IoDuplicateOutline color={flightType === "departure" ? Colors.PRM_LIGHT_BLUE : Colors.DARK_GREEN} style={{ height: "15px" }} /></div>}

                            <div style={{ display: "flex", position: "relative", alignItems: "center" }}>
                                {/*<JobCardStatus 
                                job={props?.job} 
                                //showStatus={showStatus} 
                                jobStatusLine={jobStatusLine} 
                                jobStatusColor={getJobStatusColor(props?.job)}
                                checkedIn={props?.job?.paxPositionInfo?.activity == "Checked-in" || props?.job?.originalBookingDoc?.paxPositionInfo?.paxStatus == "checkedIn"}
                            />*/}

                                {
                                    props?.job?.paxPositionInfo?.activity == "Checked-in" || props?.job?.originalBookingDoc?.paxPositionInfo?.paxStatus == "checkedIn"
                                        ?
                                        <div class="glowing-circle"></div>
                                        :
                                        <div style={{ ...statusCircle, backgroundColor: getJobStatusColor(props?.job) }} />
                                }

                                <p style={{ margin: "0px 0", textAlign: "center", fontSize: '11px', color: getJobStatusColor(props?.job), fontWeight: "700" }}>{
                                    props?.job?.paxPositionInfo?.activity == "Checked-in" ? 'Checked-in' : jobStatusLine}
                                </p>

                            </div>

                        </div>
                    </div>
                </ResizableCard>
            </div>
            <TaskAccept task={props?.job} closeModal={closeModal} toggleAcceptModal={toggleAcceptModal} />
        </>
    );
};

export default ThirtyMinLayoutJobCard;
